// Global WMS layers use the same catalogue and availability filters as country layers.
export function getWMSLayerCountries(countries: string | string[]): string[] {
  return Array.from(new Set([...(Array.isArray(countries) ? countries : [countries]), "aaa"]));
}
